var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-4 pl-3"},[_c('span',[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("mdi-arrow-left-bold")]),_vm._v(" Please select a project! ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }